












import { Vue, Component, Prop } from "vue-property-decorator";

@Component({

})

export default class TagItem extends Vue {
    @Prop({}) title: string;
    @Prop({ default: true }) needClose: boolean;
    @Prop({ default: '#787878' }) color: string;

    readonly props: typeof TagItem.prototype.$props;
    readonly listeners: Record<string, Function>;
    readonly data: typeof TagItem.prototype.$data;
}

